import data from "../../../../../src/Button/Button.docs.json";
import * as React from 'react';
export default {
  data,
  React
};